const content: { [key: string]: any } = {
  platformList: 'Platforms',
};

export default content;
